import { render, staticRenderFns } from "./VeJwSkjhList.vue?vue&type=template&id=50f12c48&scoped=true"
import script from "./VeJwSkjhList.vue?vue&type=script&lang=js"
export * from "./VeJwSkjhList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f12c48",
  null
  
)

export default component.exports